import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from 'transfix-ui/components/Table'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { IGetInboundSftpFilesReport } from 'types/graphqlTypes'
import { DownloadSftpFiles } from './DownloadSftpFiles'
import { InboundSftpFilesError } from './InboundSftpFilesError'

interface IInboundSftpFilesTableProps {
  /**
   * @example '25'
   */
  inboundConnectionConfigId: string
  report: IGetInboundSftpFilesReport
}

const useInboundSftpFilesTableStyles = makeStyles(theme => ({
  table: {
    background: 'transparent',
    marginTop: theme.spacing(1),
    '& thead': {
      background: 'transparent',
    },
    '& th:first-child, td:first-child': {
      paddingLeft: 0,
    },
    '& td': {
      borderBottom: `1px solid ${brandColors.coolGray3}`,
    },
  },
}))

export const InboundSftpFilesTable = ({
  inboundConnectionConfigId,
  report,
}: IInboundSftpFilesTableProps) => {
  const classes = useInboundSftpFilesTableStyles()

  const { errorMessage, inboundRawEdiFiles, possibleCauses, success } = report || {}

  return (
    <div>
      {!success ? (
        <InboundSftpFilesError errorMessage={errorMessage} possibleCauses={possibleCauses} />
      ) : (
        <div>
          <Table className={classes.table}>
            <TableHead>
              <TableRow tableCellType='th'>
                <TableCell>File Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {inboundRawEdiFiles && inboundRawEdiFiles.length > 0 ? (
                inboundRawEdiFiles.map((file, index) => (
                  <TableRow key={String(index)}>
                    <TableCell>{file}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell className='tc' colSpan={7}>
                    No SFTP files found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {inboundRawEdiFiles.length > 0 && (
            <DownloadSftpFiles inboundConnectionConfigId={inboundConnectionConfigId} />
          )}
        </div>
      )}
    </div>
  )
}
